/* ============================================
   Viberg.js — Mobile Footer Accordion
   ============================================ */

(function () {
  'use strict';

  /* --- Inject accordion styles once --- */
  var ACCORDION_CSS =
    '.footer-item .title.has-nav{cursor:pointer;position:relative;padding-right:20px}' +
    '.footer-item .title.has-nav::after{content:"+";position:absolute;right:0;top:50%;transform:translateY(-50%);transition:transform .3s ease}' +
    '.footer-item .title.has-nav.active::after{content:"-"}' +
    '.footer-item nav,.footer-item .footer-menu,.footer-item .site-social{transition:height .3s ease-out}';

  var style = document.createElement('style');
  style.textContent = ACCORDION_CSS;
  document.head.appendChild(style);

  /* --- Accordion toggle logic --- */
  function toggle(heading, panel) {
    var isOpen = heading.classList.toggle('active');

    if (isOpen) {
      /* Expand: measure natural height, then animate to it */
      panel.style.height = 'auto';
      var targetHeight = panel.scrollHeight + 'px';
      panel.style.height = '0px';
      /* Force reflow so the browser registers the starting value */
      panel.offsetHeight; // eslint-disable-line no-unused-expressions
      panel.style.height = targetHeight;
    } else {
      /* Collapse: snapshot current height, then animate to 0 */
      panel.style.height = panel.scrollHeight + 'px';
      panel.offsetHeight;
      panel.style.height = '0px';
    }
  }

  /* --- Initialise all footer accordions --- */
  function initFooter() {
    var items = document.querySelectorAll('.footer-item');

    items.forEach(function (item) {
      var heading = item.querySelector('h4.title.h6');
      var content = item.querySelector('.footer-menu, .site-social');
      if (!heading || !content || heading.hasAttribute('data-initialized')) return;

      /* Determine the element we actually hide (nav wrapper or content itself) */
      var panel = content.classList.contains('site-social')
        ? content.closest('nav') || content
        : content;

      /* Collapse by default */
      panel.style.height = '0';
      panel.style.overflow = 'hidden';
      heading.classList.add('has-nav');

      /* Click handler */
      heading.addEventListener('click', function () {
        toggle(heading, panel);
      });

      /* After expand animation ends, switch to auto so content reflows naturally */
      panel.addEventListener('transitionend', function () {
        if (heading.classList.contains('active')) {
          panel.style.height = 'auto';
        }
      });

      heading.setAttribute('data-initialized', 'true');
    });
  }

  /* --- Boot ---
     DOMContentLoaded is sufficient; the `load` fallback only
     matters if this script is injected after DOMContentLoaded
     has already fired (e.g. async/defer or Shopify's asset loader). */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter, { once: true });
  } else {
    initFooter();
  }

  /* ============================================
     Menu drawer small-caps digit fix
     font-variant: small-caps only shrinks letters,
     so digits inside menu-link text (e.g. "2030 LAST")
     render oversized next to the small-cap letters.
     Wrap digit runs in a span we can size down to match.
     ============================================ */
  var NUMERAL_CSS =
    '.site-nav.style--sidebar .menu-link .menu-link-num{font-size:.72em;letter-spacing:.02em;}';

  var numeralStyle = document.createElement('style');
  numeralStyle.textContent = NUMERAL_CSS;
  document.head.appendChild(numeralStyle);

  function wrapDigitsInNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (!/\d/.test(node.nodeValue)) return;
      var frag = document.createDocumentFragment();
      var parts = node.nodeValue.split(/(\d+)/);
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\d+$/.test(part)) {
          var span = document.createElement('span');
          span.className = 'menu-link-num';
          span.textContent = part;
          frag.appendChild(span);
        } else {
          frag.appendChild(document.createTextNode(part));
        }
      });
      node.parentNode.replaceChild(frag, node);
    } else if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('menu-link-num')) {
      Array.prototype.slice.call(node.childNodes).forEach(wrapDigitsInNode);
    }
  }

  function initMenuNumerals() {
    document
      .querySelectorAll('.site-nav.style--sidebar .menu-link')
      .forEach(function (link) {
        if (link.getAttribute('data-numerals-wrapped')) return;
        wrapDigitsInNode(link);
        link.setAttribute('data-numerals-wrapped', 'true');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuNumerals, { once: true });
  } else {
    initMenuNumerals();
  }

  /* ============================================
     Header background toggle — clear at top,
     white after scrolling past 10px.
     ============================================ */
  function initHeaderScrollBg() {
    var headerWrap = document.querySelector('.mount-header');
    if (!headerWrap) return;

    var THRESHOLD = 10;
    var isScrolled = false;

    function update() {
      var shouldBeScrolled = window.scrollY > THRESHOLD;
      if (shouldBeScrolled !== isScrolled) {
        isScrolled = shouldBeScrolled;
        headerWrap.classList.toggle('is-scrolled', isScrolled);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScrollBg, { once: true });
  } else {
    initHeaderScrollBg();
  }
})();